import { MsChevron, MsClose, MsRaindrop } from '@sunrise/icons'
import { computed, defineComponent, PropType, ref } from 'vue'
import { isEmpty, maxBy } from 'lodash-es'
import { MChannelStageWeatherServiceData, ReducedWeatherWarning } from '../M_Channel_Stage.interfaces'
import Warning from './icons/warning.svg?component'
import WarningLight from './icons/warning_light.svg?component'
import WarningLighter from './icons/warning_lighter.svg?component'
import WeatherIcon from './WeatherIcon.vue'
import { screenSizeDetection } from '@sunrise/shared'
import { TrackingParameter, NOT_SET, track, trackLink, createTealiumTracking } from '@sunrise/tracking'
import { CsModal, CsLink, MsHeadline, MsText } from '@sunrise/components'

export default defineComponent({
    name: 'WeatherModule',
    components: {
        MsChevron,
        MsClose,
        MsText,
        CsLink,
        WeatherIcon,
        Warning,
        WarningLight,
        WarningLighter,
        MsHeadline,
        CsModal,
        MsRaindrop,
    },
    props: {
        weatherServiceData: {
            type: Object as PropType<MChannelStageWeatherServiceData>,
            required: true,
        },
    },
    setup(props) {
        const { isScreenM } = screenSizeDetection()
        const isOpen = ref(false)
        const hasWeatherWarning =
            !isEmpty(props.weatherServiceData.weatherWarnings) &&
            props.weatherServiceData.weatherWarnings[0].warningLevel >= 1
        const hasDynamicTitle = !isEmpty(props.weatherServiceData.currentWeather.dynamicTitle)

        const baseTracking: TrackingParameter = {
            mslayer_element_data_id: 'ed0000259',
            mslayer_element_type_text: 'Home Startseite',
            mslayer_element_variant: 'native',
            mslayer_element_body_type: 'header',
            mslayer_element_position: NOT_SET,
            mslayer_element_company_name: NOT_SET,
            mslayer_element_count: NOT_SET,
            mslayer_element_detail_start_date: NOT_SET,
            mslayer_element_id: NOT_SET,
        }

        const openTracking = {
            ...baseTracking,
            mslayer_element_text: 'Wetter_open',
        }
        const closeTracking = {
            ...baseTracking,
            mslayer_element_text: 'Wetter_close',
        }

        const toggleOpen = () => {
            isOpen.value ? track(closeTracking) : track(openTracking)
            isOpen.value = !isOpen.value
        }

        const trackWeatherClick = (e: MouseEvent) => {
            const target = e.currentTarget as HTMLAnchorElement
            const trackingData = createTealiumTracking({
                ...baseTracking,
                mslayer_element_text: 'zum_Wetter',
            })
            trackLink(e, target, [trackingData])
        }

        const highestWeatherWarning = computed<ReducedWeatherWarning | undefined>(() =>
            maxBy(props.weatherServiceData.weatherWarnings, (warning) => warning.warningLevel),
        )

        return {
            toggleOpen,
            isOpen,
            isScreenM,
            hasWeatherWarning,
            hasDynamicTitle,
            trackWeatherClick,
            highestWeatherWarning,
        }
    },
})
